import { Component } from '@angular/core';
export class TdMenuComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdMenuComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdMenuComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMenuComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
